<template>
    <v-container class="pa-5" fluid>
        <page-title>Rankingi</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.type_id"
                                label="Typ rankingu"
                                :items="rankingTypes"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono typu rankingu"
                                solo
                                hide-details
                                @change="changeFilter(true)"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.rankingGroup_id"
                                label="Grupa procesu"
                                :items="rankingGroups"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono grupy procesu"
                                solo
                                clearable
                                hide-details
                                :disabled="!rankingGroups.length === 0"
                                @click:clear="clearFilter('rankingGroup_id')"
                                @change="changeFilter(false)"
                            />
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        :value="setMonthName(filters.startDateTime__lte)"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        class="mt-0"
                                        :disabled="filters.type_id === 20"
                                        v-on="on"
                                        @input="changeFilter"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    :disabled="filters.type_id === 20"
                                                    data-sentry-label="Zmiana daty rankingu"
                                                    @click="getForwardMonth()"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    :disabled="filters.type_id === 20"
                                                    data-sentry-label="Zmiana daty rankingu"
                                                    @click="getPreviousMonth()"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.startDateTime__lte"
                                    type="month"
                                    @change="changeFilter(false)"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="actionLoading.generateReport"
                    @click="generateUsersRankingReport"
                >
                    <v-icon
                        v-if="!actionLoading.generateReport"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="usersRanking"
                        :loading="usersRankingLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="usersRankingData"
                        @pagination="updatePagination"
                    >
                        <template #item.user="{item}">
                            <template v-if="item.user">
                                <template v-if="item.user.firstName && item.user.lastName">
                                    {{ item.user.firstName }} {{ item.user.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.user.username }}
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.score="{item}">
                            {{ item.score }}
                        </template>
                        <template #item.startDateTime="{item}">
                            {{ formatDate(item.startDateTime, withTime = false) }}
                        </template>
                        <template #item.endDateTime="{item}">
                            {{ formatDate(item.endDateTime, withTime = false, placeholder = true, {timeZone: 'UTC'}) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import parse from '@/mixins/parse.js'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import { endOfMonth, addMonths, subMonths, format } from 'date-fns'
import { errorHandler } from '@/utils/errorHandler'


export default {
    name: 'UsersRanking',
    components: {
        PageTitle
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        filters,
        pagination,
        parse
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('reportsAndAnalysis/reports/clearUsersRankingFilters')
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            menuFrom: false,
            typeChanged: false,
            actionLoading: {
                generateReport: false,
            },
            headers: [
                {
                    text: 'Pracownik',
                    value: 'user',
                    sortable: false,
                    align: 'start',
                    width: 250
                },
                {
                    text: 'Punkty',
                    value: 'score',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Data rozpoczęcia',
                    value: 'startDateTime',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Data zakończenia',
                    value: 'endDateTime',
                    sortable: false,
                    align: 'center',
                },
            ],
            user: {},
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        usersRanking() {
            return this.$store.state.reportsAndAnalysis.reports.usersRanking.usersRanking
        },
        usersRankingLoading() {
            return this.$store.state.reportsAndAnalysis.reports.usersRanking.usersRankingLoading
        },
        rankingTypes() {
            return this.$store.state.reportsAndAnalysis.reports.usersRanking.rankingTypes
        },
        rankingGroups() {
            return this.$store.state.reportsAndAnalysis.reports.usersRanking.rankingGroups
        },
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.reports.usersRanking.usersRankingFilters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (item == 'startDateTime__lte') {
                        const selectedMonth = new Date(filters['startDateTime__lte'])
                        const startOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1)
                        const lastDayOfTheMonth = endOfMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth()))

                        filters['startDateTime__lte'] = `${format(lastDayOfTheMonth, 'YYYY-MM-DD')}T23:59:59Z`
                        filters['startDateTime__gte'] = `${format(startOfMonth, 'YYYY-MM-DD')}T00:00:00Z`
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    mounted() {
        this.$store.dispatch('administration/getUser', this.userId )
            .then(response => {
                this.user = response.data
            })
            .catch(error => {
                errorHandler(error)
            })

        this.$store.dispatch('reportsAndAnalysis/reports/getRankingTypes')
            .then(() => {
                this.getRankingGroups()
                this.getUsersRanking()
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        setMonthName() {
            if (this.filters.startDateTime__lte) {
                return new Date(this.filters.startDateTime__lte).toLocaleString('pl', {month: 'long', year: 'numeric'})
            }
        },
        generateUsersRankingReport() {
            this.actionLoading.generateReport = true
            this.$store.dispatch('reportsAndAnalysis/reports/generateUsersRankingReport', {
                query: this.filterQuery,
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReport = false
                })
        },
        getPreviousMonth() {
            if (Date.parse(this.filters.startDateTime__lte)) {
                const selectedMonth = new Date(this.filters['startDateTime__lte'])
                const startOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1)
                const previousMonth = subMonths(new Date(startOfMonth.getFullYear(), startOfMonth.getMonth(), startOfMonth.getDate()), 1)

                this.filters['startDateTime__lte'] = format(previousMonth, 'YYYY-MM-DD')
                this.changeFilter(false)
            }
        },
        getForwardMonth() {
            if (Date.parse(this.filters.startDateTime__lte)) {
                const selectedMonth = new Date(this.filters['startDateTime__lte'])
                const startOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1)
                const nextMonth = addMonths(new Date(startOfMonth.getFullYear(), startOfMonth.getMonth(), startOfMonth.getDate()), 1)

                this.filters['startDateTime__lte'] = format(nextMonth, 'YYYY-MM-DD')
                this.changeFilter(false)
            }
        },
        getUsersRanking() {
            this.$store.dispatch('reportsAndAnalysis/reports/getUsersRanking', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getRankingGroups() {
            this.$store.dispatch('reportsAndAnalysis/reports/getRankingGroups', this.filters.type_id)
                .catch(error => {
                    errorHandler(error)
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisReportsReports' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter(typeChanged) {
            if (typeChanged) {
                this.getRankingGroups()
                this.typeChanged = typeChanged
                const currentMonth = this.filters.startDateTime__lte = format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'YYYY-MM-DD')

                this.filters.type_id === 10 ? currentMonth : this.filters.startDateTime__lte = null
            }
            this.$store.dispatch('reportsAndAnalysis/reports/setUsersRankingFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.resetPagination()
            this.getUsersRanking()
            this.typeChanged = false
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getUsersRanking()
            }
            this.clearPaginationPending()
        }
    }
}

</script>